import { appUrl } from '@configs/variables';
import { appendQueryParams } from '@utils/appendQueryParams';
import { PaymentLinkRedirectParams } from '@constants/paymentLink';

function getUrlParam(name: string, defaultValue = ''): string {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  const results = regex.exec(location.search);
  return results === null ? defaultValue : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export default getUrlParam;

export const getConfirmationUrl = (paymentLinkId: string, isSura: boolean): string => {
  const redirect_uri = getUrlParam(PaymentLinkRedirectParams.REDIRECT_URL);
  const isV2 = window.location.pathname.includes('/v2');

  return appendQueryParams(
    isSura
      ? `${appUrl}/sura/pay/${paymentLinkId}/payment-methods`
      : `${appUrl}/pay${isV2 ? '/v2' : ''}/${paymentLinkId}`,
    { redirect_uri },
    { clearEmpty: true },
  );
};

export const getCurrentUrl = (paymentLinkId: string): string => {
  const origin = window.location.origin;
  const isV2 = window.location.pathname.includes('/v2');
  return `${origin}/pay${isV2 ? '/v2' : ''}/${paymentLinkId}`;
};

export const getProcessingUrl = (): string => {
  const origin = window.location.origin;
  const isV2 = window.location.pathname.includes('/v2');
  return `${origin}/pay${isV2 ? '/v2' : ''}/processing`;
};
